<template>
  <div :class="'template-residential-template-page' + id">
    <div class="template-residential-template-page__header">
      <div class="template-residential-template-page__header-cover-wrapper">
        <Slider
          class="template-residential-template-page__header-cover"
          v-if="coverImages.length"
          :value="coverImages"
          :display-thumbnail="true"
          :manual-navigation="true"
        />
      </div>
      <Summary :value="data" />
    </div>
    <div class="template-residential-template-page__content container">
      <Info :value="data" class="template-residential-template-page__content-info" />
      <Gallery
        v-if="floorplan.length"
        :value="floorplan"
        scroll-anchor="floorplan"
        class="template-residential-template-page__content-floorplan"
        size="contain"
      />
    </div>
    <div
      v-if="attachments.length"
      class="template-residential-template-page__attachments container"
    >
      <Attachments :attachments="attachments" />
    </div>
    <Masonry :value="gallery" class="template-residential-template-page__masonry" />
  </div>
</template>

<script>
import Slider from '@kvass/media-render/Slider'
import Gallery from '@kvass/template-gallery/Types/Gallery'
import Masonry from '@kvass/template-gallery/Types/Masonry'
import { getResidentialTemplate } from './api'
import Attachments from './components/Attachments'
import Info from './components/Info'
import Summary from './components/Summary'

export default {
  props: {
    id: null,
  },
  data() {
    return {
      promise: null,
      data: null,
    }
  },
  watch: {
    id: {
      immediate: true,
      handler(val) {
        this.fetch(val)
      },
    },
  },
  computed: {
    coverImages() {
      return this.$path('data.media.cover') || []
    },
    gallery() {
      return this.$path('data.media.gallery') || []
    },
    floorplan() {
      return (this.$path('data.media.floorplan') || []).map(e => ({
        caption: e.name,
        url: e.url,
        type: e.type,
      }))
    },
    attachments() {
      return this.$path('data.media.attachments') || []
    },
  },
  methods: {
    goToProject() {
      return this.$router.push({ name: 'Project' })
    },

    fetch() {
      return (this.promise = getResidentialTemplate({
        id: this.id,
      }).then(data => {
        this.data = data.ResidentialTemplate

        return data
      }))
    },
  },
  metaInfo() {
    return {
      title: this.$path('data.name') || this.$t('loading', { resource: '' }),
    }
  },
  components: {
    Summary,
    Masonry,
    Info,
    Gallery,
    Slider,
    Attachments,
  },
}
</script>

<style lang="scss">
@mixin aspect-ratio($width, $height) {
  position: relative;
  &:before {
    display: block;
    content: '';
    width: 100%;
    padding-top: ($height / $width) * 100%;
  }
  > .content {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
}

.template-residential-template-page {
  &__header {
    pointer-events: none;
    $height: 60vh;
    display: flex;

    @media (max-width: 1100px) {
      flex-direction: column;
    }

    &-cover {
      &-wrapper {
        flex-basis: 50%;
        flex-grow: 1;
        height: $height;
        @media (max-width: 1100px) {
          height: initial;
        }
      }
      background-color: grey;
      @include aspect-ratio(16, 9);
    }
  }

  &__content {
    flex-basis: 50%;
    flex-grow: 1;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
    padding: 6rem 0;
    grid-gap: 4rem 8rem;

    &-floorplan {
      min-height: 40vh;
    }
  }

  &__attachments {
    padding-block: 0 6rem;
  }
}
</style>
